import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* searchTag(action: any): any {
    const yieldPuts = [{ type: ACTIONS.TAGS.SEARCH_TAG, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.TAGS.SEARCH_TAG, action.payload, true, yieldPuts);
}

export function* addUpdateTag(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TAGS.ADD_UPDATE_TAG, action.payload, true);
}

export function* deleteTag(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TAGS.DELETE_TAG, action.payload, true);
}

export function* tagDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.TAGS.TAG_DETAILS, action.payload, true);
}
